import styled from "styled-components";

import { layout } from "/styles";

export const OptionsWrapper = styled.div(layout.spacedChildrenVertical("gutter"));
